module.exports = __webpack_public_path__ + "media/images/poet_bg-62ecf82ffadc7e5ab29e2c67e86b74b2.jpg";